module.exports = __webpack_public_path__ + "static/media/Bookmark.41e92487.svg";